<div class="error-container">
  <img
    src="/assets/crane.svg"
    class="error-icon"
  />
  <p class="error-message">An error occurred, please check back in a few minutes.</p>
  <p class="error-contact">If this issue persists, please contact support&#64;constrafor.com</p>
</div>
